class Dropdown {
    /**
     * @param {Element} dropdown
     * @param {Number} timeout
     */
    constructor(dropdown, timeout = 300) {
        this.dropdown = dropdown;
        this.timeout = timeout;

        this.button = dropdown.querySelector('.dropdown__button');
        this.body = dropdown.querySelector('.dropdown__body');

        this.opened = false;
        this.pending = false;

        this.open = this.open.bind(this);
        this.close = this.close.bind(this);

        this.button.addEventListener('click', this.open);
        this.dropdown
            .querySelector('.dropdown__close')
            .addEventListener('click', this.close);
        this.dropdown
            .querySelector('.dropdown__overlay')
            .addEventListener('click', this.close);
        this.dropdown
            .querySelectorAll('.dropdown__list-item')
            .forEach((link) => link.addEventListener('click', this.close));

        window.addEventListener('mousedown', ({ target }) => {
            if (!this.opened || this.body.contains(target)) return;

            this.close();
        });
    }

    open() {
        if (this.pending) return;

        this.dropdown.classList.add('show');
        this.opened = true;

        document.body.classList.add('overflow_hidden-tablets');
        window.requestAnimationFrame(() => {
            this.dropdown.classList.add('active');
        });
    }

    close() {
        if (this.pending) return;

        this.dropdown.classList.remove('active');
        this.opened = false;

        document.body.classList.remove('overflow_hidden-tablets');

        this.pending = true;
        setTimeout(() => {
            this.dropdown.classList.remove('show');
            this.pending = false;
        }, this.timeout);
    }
}

export default Dropdown;
